import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationPaletteCardTemplateDb = {
  paletteId: string;
  cardTemplateId: string;
  order: number;
}
const initial: RelationPaletteCardTemplateDb = {
  paletteId: '',
  cardTemplateId: '',
  order: 0
};

export type RelationPaletteCardTemplateDbHashType = {
  [key in string]: RelationPaletteCardTemplateDb;
}

export type RelationPaletteCardTemplateAddPayload = {
  id?: string;
} & RelationPaletteCardTemplateDb;
export type RelationPaletteCardTemplateUpdatePayload = {
  id: string;
} & { [P in keyof RelationPaletteCardTemplateDb]?: RelationPaletteCardTemplateDb[P] };

export type RelationPaletteCardTemplateDbState = {
  relationPaletteCardTemplates: RelationPaletteCardTemplateDbHashType;
}

export const  generateRelationPaletteCardTemplateId = (): string =>  generateId('rpct');
let initialState: RelationPaletteCardTemplateDbState = { relationPaletteCardTemplates: {} };
const key = 'relationPaletteCardTemplates';

const relationPaletteCardTemplateDbSlice = createSlice({
  name: 'relationPaletteCardTemplateDb',
  initialState,
  reducers: {
    initializeRelationPaletteCardTemplates(state: RelationPaletteCardTemplateDbState) {
      state.relationPaletteCardTemplates = {};
    },
    addRelationPaletteCardTemplate(state: RelationPaletteCardTemplateDbState, action: PayloadAction<RelationPaletteCardTemplateAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationPaletteCardTemplateId();
      state.relationPaletteCardTemplates[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationPaletteCardTemplate(state: RelationPaletteCardTemplateDbState, action: PayloadAction<RelationPaletteCardTemplateUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationPaletteCardTemplates[id] === undefined) {
        console.log(`*** RelationPaletteCardTemplate not found: ${id}`);
      } else {
        const newData = { ...state.relationPaletteCardTemplates[id], ...obj };
        state.relationPaletteCardTemplates[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationPaletteCardTemplate(state: RelationPaletteCardTemplateDbState, action: PayloadAction<RelationPaletteCardTemplateUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationPaletteCardTemplates[id];
      deleteData(key, id);
    },
    saveRelationPaletteCardTemplates(state: RelationPaletteCardTemplateDbState) {
      saveAllData(key, state.relationPaletteCardTemplates);
    },
    signUpRelationPaletteCardTemplates(state: RelationPaletteCardTemplateDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationPaletteCardTemplates, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationPaletteCardTemplateDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationPaletteCardTemplates = updatedValues;
      if (changed) saveAllData(key, state.relationPaletteCardTemplates);
    })
  }
})

export const { initializeRelationPaletteCardTemplates, addRelationPaletteCardTemplate, updateRelationPaletteCardTemplate, deleteRelationPaletteCardTemplate, saveRelationPaletteCardTemplates, signUpRelationPaletteCardTemplates } = relationPaletteCardTemplateDbSlice.actions;
export default relationPaletteCardTemplateDbSlice.reducer;
